function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.select.addEventListener('change', this.onSelectChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      );
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    if (this.select) {
      this.select.value = event.target.value;
    }
    this.validateQtyRules();
  }

  onSelectChange(event) {
    if (this.input) {
      this.input.value = event.target.value;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach(
      (button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.getElementById('gorgias-chat-container').style.display = 'block';
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
      document.getElementById('gorgias-chat-container').style.display = 'none';
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderControlWrapper = this.querySelector('.slider-buttons') || this.closest('section').querySelector('.slider-buttons');

    if (this.sliderControlWrapper != null) {
      this.prevButton = this.sliderControlWrapper.querySelector('button[name="previous"]');
      this.nextButton = this.sliderControlWrapper.querySelector('button[name="next"]');

      this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
      );
      this.sliderControlLinksArray.forEach((link) =>
        link.addEventListener('click', this.linkToSlide.bind(this))
      );
    }

    //if (this.slider.classList.contains('thumbnail-list') && document.querySelector("[data-ab-product]") && document.querySelector("[data-ab-active]")) return;
    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    document.addEventListener('shopify:block:select', (e) => {
      console.log(e);
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );

      // Update mobile progress bar
      if (document.getElementById('myBar') != null) {
        const progressBar = (this.currentPage / this.totalPages) * 100;
        console.log('Second: ' + progressBar);
        document.getElementById('myBar').style.width = progressBar + '%';
      }
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((link, index) => {
        if (index == this.currentPage - 1) {
          this.sliderControlButtons[index].classList.add(
            'slider-counter__link--active'
          );
          this.sliderControlButtons[index].setAttribute('aria-current', true);
        } else {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        }
      });
    }

    if (this.enableSliderLooping || (!this.prevButton && !this.nextButton))
      return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (!this.nextButton) return;
    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 4;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

let newsletterForm = {
  init() {
    let form = document.querySelector('.newsletter-form');
    let submitBtn = form.querySelector('button[type="submit"]');
    let checkbox = document.getElementById('NewsletterConsent');

    if (form && submitBtn && checkbox) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();

        let input = form.querySelector('.field__input');

        if (checkbox.checked && input.value != '') {
          form.submit();
        } else {
          let error = form.querySelector('.contact__field-error');

          if (error) {
            error.classList.remove('hide');
          }
        }
      });
    }
  },
};

document.addEventListener('DOMContentLoaded', (e) => {
  //newsletterForm.init();
});

class Usps extends HTMLElement {
  constructor() {
    super();

    if (window.innerWidth <= 750) {
      this.context = this;
      this.clones = this.context.querySelectorAll('.cloned');
      this.disableScroll = false;
      this.scrollW = 0;
      this.scrollPos = 0;
      this.clonesWidth = 0;
      this.i = 0;

      this.reCalc();

      this.context.addEventListener(
        'scroll',
        (e) => {
          window.requestAnimationFrame(this.scrollUpdate.bind(this));
        },
        false
      );

      window.addEventListener(
        'resize',
        (e) => {
          window.requestAnimationFrame(this.reCalc.bind(this));
        },
        false
      );

      setInterval((e) => {
        this.setScrollPos(this.context.scrollLeft + 1);
      }, 10);
    }
  }

  getScrollPos() {
    return (
      (this.context.pageXOffset || this.context.scrollLeft) -
      (this.context.clientLeft || 0)
    );
  }

  setScrollPos(pos) {
    this.context.scrollLeft = pos;
  }

  getClonesWidth() {
    this.clonesWidth = 0;

    for (this.i = 0; this.i < this.clones.length; this.i += 1) {
      this.clonesWidth = this.clonesWidth + this.clones[this.i].offsetWidth;
    }

    return this.clonesWidth;
  }

  reCalc() {
    this.scrollPos = this.getScrollPos();
    this.scrollW = this.context.scrollWidth;
    this.clonesWidth = this.getClonesWidth();

    if (this.scrollPos <= 0) {
      this.setScrollPos(1); // Scroll 1 pixel to allow upwards scrolling
    }
  }

  scrollUpdate() {
    if (!this.disableScroll) {
      this.scrollPos = this.getScrollPos();

      if (this.clonesWidth + this.scrollPos >= this.scrollW) {
        // Scroll to the left when you’ve reached the right
        this.setScrollPos(1); // Scroll down 1 pixel to allow leftwards scrolling
        this.disableScroll = true;
      } else if (this.scrollPos <= 0) {
        // Scroll to the left when you reach the right
        this.setScrollPos(this.scrollW - this.clonesWidth);
        this.disableScroll = true;
      }
    }

    if (this.disableScroll) {
      // Disable scroll-jumping for a short time to avoid flickering
      window.setTimeout((e) => {
        this.disableScroll = false;
      }, 40);
    }
  }
}

class InstantBuyForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.instantBuyButtons = this.querySelectorAll('button.instant-buy-button');
    this.bundlePacks = this.querySelectorAll('.bundle-pack');
    this.autoShip = this.querySelectorAll('input[name="subscription"]');
    this.isSubscription = true;

    if (Array.from(this.autoShip).length === 0) {
      this.isSubscription = false
    }

    if (this.form.querySelector('.auto-ship-container')) {
      if (
        this.form
          .querySelector('.auto-ship-container')
          .querySelectorAll('.bundle-pack').length
      ) {
        this.form
          .querySelector('.auto-ship-container')
          .querySelectorAll('.bundle-pack')
          .forEach((bundlePack) => {
            const price = bundlePack.dataset.subscriptionMoney;
            const saving = bundlePack.dataset.subscriptionSaving;
            bundlePack.querySelector('.price-item--last').innerHTML = price;
            if (bundlePack.querySelector('.saving-badge') != null)
              bundlePack.querySelector('.saving-badge').textContent = saving;
          });

        this.selectedOption = this.querySelector('.bundle-pack.active').dataset;
      }
    }

    if (this.instantBuyButtons) {
      for (const submitButton of this.instantBuyButtons) {
        submitButton.addEventListener(
          'click',
          this.instantBuyHandler.bind(this)
        );
      }
    }

    if (this.bundlePacks.length > 0) {
      this.bundlePacks.forEach((bundlePack) => {
        bundlePack.addEventListener(
          'click',
          this.onBundlePackChange.bind(this)
        );
      });
    }
    if (this.autoShip) {
      this.autoShip.forEach((autoShip) => {
        autoShip.addEventListener('change', this.onAutoShipChange.bind(this));
      });
    }
  }

  connectedCallback () {
    this.updatePrice();
  }

  onAutoShipChange(e) {
    const value = e.currentTarget.checked && e.currentTarget.id === 'auto-ship';
    const autoShipContainer = this.querySelector('.auto-ship-container');
    const oneTimeContainer = this.querySelector('.one-time-container');
    const buyWrapper = this.querySelector('.buy-wrapper');
    const autoShipSelector = this.querySelector('.auto-ship-select');
    if (value) {
      autoShipContainer.classList.add('plan-container-open');
      oneTimeContainer.classList.remove('plan-container-open');
      buyWrapper.style.bottom = oneTimeContainer.offsetHeight + 8 + 'px';
      autoShipSelector.setAttribute('name', 'selling_plan');
      this.isSubscription = true;
      this.form.querySelector('input[name="id"]').value =
        this.selectedOption.subscriptionId;
    } else {
      autoShipContainer.classList.remove('plan-container-open');
      oneTimeContainer.classList.add('plan-container-open');
      buyWrapper.style.bottom = 0 + 'px';
      autoShipSelector.removeAttribute('name');
      this.isSubscription = false;
      this.form.querySelector('input[name="id"]').value =
        this.selectedOption.id;
    }
    this.updatePrice();
  }

  onBundlePackChange(e) {
    this.selectedOption = e.currentTarget.dataset;
    const updateAutoship = this.autoShip.length > 0;
    this.bundlePacks.forEach((bundlePack) => {
      bundlePack.classList.remove('active');
    });
    if (updateAutoship) {
      const currentURl = this.selectedOption.url;
      this.form
        .querySelectorAll(`[data-url="${currentURl}"]`)
        .forEach((bundlePack) => {
          bundlePack.classList.add('active');
        });
    } else {
      e.currentTarget.classList.add('active');
    }
    if (this.isSubscription) {
      this.form.querySelector('input[name="id"]').value =
        this.selectedOption.subscriptionId;
    } else {
      this.form.querySelector('input[name="id"]').value =
        this.selectedOption.id;
    }
    const selling_plan = JSON.parse(this.selectedOption.sellingPlans || '[]');
    let autoShipOptions = '';
    selling_plan.forEach((plan) => {
      autoShipOptions += `<option value="${plan.id}">${plan.name}</option>`;
    });
    const autoShipSelector = this.querySelector('.auto-ship-select');
    if (autoShipSelector) {
      autoShipSelector.innerHTML = autoShipOptions;
    }
    // Update the main product image
    this.updateMainImage(e.currentTarget.querySelector('img'));
    this.scrollToMainImage();

    this.updatePrice();
  }

  updateMainImage(bundleImg) {
    const mainProductImage = document.getElementById('product-image-1');
    // Extract the path after '/cdn/' from the bundle image URL
    const newPath = bundleImg.src.split('/cdn/')[1].split('?')[0];
    // Create a new src using the base URL up to '/cdn/' and append the new path
    const baseUrl = mainProductImage.src.split('/cdn/')[0];
    mainProductImage.src = `${baseUrl}/cdn/${newPath}?${new URLSearchParams(bundleImg.src.split('?')[1])}`;

    // Update srcset similarly, ensuring we replace the entire path after '/cdn/' and not just the filename
    mainProductImage.srcset = mainProductImage.srcset.split(',').map(srcsetItem => {
      const [url, descriptor] = srcsetItem.trim().split(' ');
      return `${baseUrl}/cdn/${newPath}?${new URLSearchParams(url.split('?')[1])} ${descriptor}`;
    }).join(', ');
  }

  scrollToMainImage() {
    const mainProductImage = document.getElementById('product-image-1');
    const sliderComponent = mainProductImage.closest('slider-component');
    if (!sliderComponent) return; // Ensure sliderComponent is found

    const mainImageIndex = Array.from(sliderComponent.sliderItems).indexOf(
      mainProductImage.closest('.slider__slide')
    );

    // Check if the sliderControlLinksArray element at mainImageIndex is defined
    if (sliderComponent.sliderControlLinksArray && sliderComponent.sliderControlLinksArray[mainImageIndex]) {
      sliderComponent.linkToSlide({
        preventDefault: () => {},
        currentTarget: sliderComponent.sliderControlLinksArray[mainImageIndex],
      });
    }
  }

  updatePrice() {
    const productInfo = this.parentNode;
    const productPrice = productInfo.querySelector(
      '.price_wrapper .no-js-hidden'
    );
    let url = `${this.selectedOption.url}`;
    if (this.isSubscription) {
      url = `${this.selectedOption.subscriptionUrl}`;
    }
    fetch(`${url}?view=price`)
      .then((response) => response.text())
      .then((text) => {
        productPrice.innerHTML = text;
      });
  }

  instantBuyHandler(e) {
    e.preventDefault();
    Rebuy.SmartCart.skip_open = true;

    this.clearCart().then(() => {
      this.addItem().then((result) => {
        window.location.href = '/checkout';
      });
    });
  }

  async clearCart() {
    const result = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });

    return result;
  }

  async addItem() {
    let formData = new FormData(this.form);

    for (const entry of formData) {
      console.log(entry);
    }

    let items = [
      {
        id: formData.get('id'),
        quantity: formData.get('quantity'),
        selling_plan: formData.getAll('selling_plan').slice(-1)[0],
      },
    ];
    if (this.bundlePacks.length > 0) {
      if (this.querySelector('.bundle-pack.active').dataset.extraProduct) {
        items.push({
          id: this.querySelector('.bundle-pack.active').dataset.extraProduct,
          quantity: 1,
        });
      }
    }

    const result = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: items,
      }),
    });

    return result;
  }
}

document.addEventListener('DOMContentLoaded', (e) => {
  customElements.define('custom-usps', Usps);
  customElements.define('instant-buy-form', InstantBuyForm);
  if (!document.body.classList.contains('data-ab-test-100468763')) {
    if (document.querySelector('#one-time')) {
      document.querySelector('#one-time').dispatchEvent(new Event('change'));
    }
  }
  let anchorTos = document.querySelectorAll('[data-anchor-to]');

  if (anchorTos) {
    for (const anchorTo of anchorTos) {
      anchorTo.addEventListener('click', (e) => {
        let destination = document.getElementById(e.target.dataset.anchorTo);

        console.log(destination);

        if (destination) {
          let viewportOffset = destination.getBoundingClientRect();
          let top = viewportOffset.top + document.documentElement.scrollTop;

          setTimeout(() => {
            window.scrollTo(0, Math.ceil(top) - 100);
          }, 0);
        }
      });
    }
  }
});

/* Smart Cart subscribe and save */
function runRebuyABTest() {
  const normalProductHandles = [
    'toothpaste-3-pack',
    'gutology-probiotic-toothpaste-5-pack',
  ];
  const subscriptionProductHandles = [
    'gutology-probiotic-toothpaste-3-pack-subscription',
    'gutology-probiotic-toothpaste-5-pack-subscription',
  ];
  function replaceProductWithSubscription(handle, qty) {
    const newHandle = normalProductHandles.includes(handle)
      ? subscriptionProductHandles[normalProductHandles.indexOf(handle)]
      : normalProductHandles[subscriptionProductHandles.indexOf(handle)];
    fetch('/products/' + newHandle + '.js')
      .then((response) => response.json())
      .then((data) => {
        const item = {
          id: data.variants[0].id,
          quantity: qty,
        };
        if (data.requires_selling_plan) {
          item.selling_plan =
            data.variants[0].selling_plan_allocations[0].selling_plan_id;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [item],
          }),
        });
        const removeItemOnce = (event) => {
          event.detail.cart.items().forEach((item) => {
            if (item.handle === handle) {
              window.Rebuy.SmartCart.removeItem(item);
            }
          });
          document.removeEventListener('rebuy:cart.change', removeItemOnce);
        };
        document.addEventListener('rebuy:cart.change', removeItemOnce);
      });
  }
  function addSubscriptionSwitchDropdown(item, days, index) {
    const html = `<div class="rebuy-cart__flyout-item-subscription">
      <select aria-label="Subscription delivery frequency" class="rebuy-select muted">
        <optgroup label="${
          window.Rebuy.SmartCart.settings.switch_to_subscription.language
            .onetime_option_group_label
        }">
          <option data-handle="${
            subscriptionProductHandles[index]
          }" value="onetime">${
      window.Rebuy.SmartCart.settings.switch_to_subscription.language
        .onetime_option_label
    }</option>
        </optgroup>
        <optgroup label="${window.Rebuy.SmartCart.settings.switch_to_subscription.language.subscription_option_group_label.replace(
          /{{ subscription_discount }}/g,
          subscription_bundle_percent_saving
        )}">
          <option selected value="${window.Rebuy.SmartCart.settings.switch_to_subscription.language.subscription_option_label
            .replace(/{{ frequency }}/g, days)
            .replace(/{{ interval }}/g, 'days')}"
          >${window.Rebuy.SmartCart.settings.switch_to_subscription.language.subscription_option_label
            .replace(/{{ frequency }}/g, days)
            .replace(/{{ interval }}/g, 'days')}</option>
        </optgroup>
      </select>
    </div>`;
    const element = new DOMParser().parseFromString(html, 'text/html').body
      .firstChild;
    item.appendChild(element);
    item
      .querySelector('.rebuy-cart__flyout-item-subscription select')
      .addEventListener('change', (e) => {
        if (e.target.value == 'onetime') {
          window._conv_q = window._conv_q || [];
          _conv_q.push(['triggerConversion', '100447700']);
          const selectedOption = item.querySelector(
            '.rebuy-cart__flyout-item-subscription select option:checked'
          );
          const qty = parseInt(
            item
              .querySelector('.rebuy-cart__flyout-item-quantity-widget-label')
              .innerText.split('Subscription')[1]
          );
          replaceProductWithSubscription(selectedOption.dataset.handle, qty);
        }
      });
  }
  function addUpgradeToSubscriptionButton(item, handle, qty) {
    const html = `<div class="rebuy-cart__flyout-item-subscription">
      <button type="button" class="rebuy-button outline">
        <span>${window.Rebuy.SmartCart.settings.switch_to_subscription.language.upgrade_to_subscription_label.replace(
          /{{ subscription_discount }}/g,
          subscription_bundle_percent_saving
        )}</span>
      </button>
    </div>`;
    const element = new DOMParser().parseFromString(html, 'text/html').body
      .firstChild;
    item.appendChild(element);
    item
      .querySelector('.rebuy-cart__flyout-item-subscription button')
      .addEventListener('click', (e) => {
        e.preventDefault();

        e.target.setAttribute('disabled', 'disabled');
        e.target.innerText =
          window.Rebuy.SmartCart.settings.switch_to_subscription.language.upgrading_label;
        window._conv_q = window._conv_q || [];
        _conv_q.push(['triggerConversion', '100447699']);
        replaceProductWithSubscription(handle, qty);
      });
  }
  function updateRebuyCart() {
    let classes = '';
    normalProductHandles.forEach((productHandle) => {
      classes += `.product-${productHandle},`;
    });
    classes = classes.slice(0, -1); // Remove the last comma
    const items = document.querySelectorAll(classes);
    items.forEach((item) => {
      const handle = item.className
        .split(' ')
        .find((cls) => cls.startsWith('product-'))
        .split('product-')[1];
      const qty = parseInt(
        item
          .querySelector('.rebuy-cart__flyout-item-quantity-widget-label')
          .innerText.split('Pack')[1]
      );
      item.classList.add('bundle-item-cart');

      const button = item.querySelector(
        '.rebuy-button:not([data-event-added])'
      );
      if (button == null) {
        if (item.querySelector('.rebuy-cart__flyout-item-subscription') != null)
          return;
        addUpgradeToSubscriptionButton(item, handle, qty);
      } else {
        const newButton = button.cloneNode(true);
        newButton.setAttribute('data-event-added', 'true');
        newButton.innerText =
          window.Rebuy.SmartCart.settings.switch_to_subscription.language.upgrade_to_subscription_label.replace(
            /{{ subscription_discount }}/g,
            subscription_bundle_percent_saving
          );
        newButton.setAttribute('data-product-handle', handle);

        newButton.addEventListener('click', (e) => {
          e.preventDefault();
          newButton.setAttribute('disabled', 'disabled');
          newButton.innerText =
            window.Rebuy.SmartCart.settings.switch_to_subscription.language.upgrading_label;
          replaceProductWithSubscription(handle, qty);
        });
        button.parentNode.replaceChild(newButton, button);
      }
    });

    classes = '';
    subscriptionProductHandles.forEach((productHandle) => {
      classes += `.product-${productHandle},`;
    });
    classes = classes.slice(0, -1);
    const subscriptionItems = document.querySelectorAll(classes);
    subscriptionItems.forEach((item) => {
      if (item.querySelector('.rebuy-cart__flyout-item-subscription') != null) {
        item
          .querySelectorAll('.rebuy-cart__flyout-item-subscription')
          .forEach((element) => {
            element.remove();
          });
      }
      let product_index = 0;
      subscriptionProductHandles.forEach((productHandle) => {
        if (item.classList.contains(`product-${productHandle}`)) {
          product_index = subscriptionProductHandles.indexOf(productHandle);
        }
      });
      let days = 90;
      if (product_index == 1) {
        days = 150;
      }

      addSubscriptionSwitchDropdown(item, days, product_index);
    });
  }
  (() => {
    const config = { attributes: false, childList: true, subtree: true };
    const observer = new MutationObserver(() => {
      observer.disconnect();
      updateRebuyCart();
      observer.observe(document.querySelector('#rebuy-cart'), config);
    });
    function waitForSmartCart() {
      if (document.querySelector('#rebuy-cart') == null) {
        setTimeout(waitForSmartCart, 100);
      } else {
        updateRebuyCart();
        observer.observe(document.querySelector('#rebuy-cart'), config);
      }
    }
    waitForSmartCart();
  })();
}

if(window.ABtestID == 100469840){
  runRebuyABTest();
} else {
  window.addEventListener('loadABtest', () => {
    runRebuyABTest();
  });
}

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.searchParams = new URLSearchParams(location.search);

    this.previousUrl = this.dataset.previousUrl;
    this.nextUrl = this.dataset.nextUrl;
    this.currentPage = this.dataset.currentPage;
    this.currentUrl = this.dataset.currentUrl;

    this.targetList = this.querySelector('ul');
    this.elementToObserve = this.querySelector('.infinite-scroll--observed');
    this.loadPrevious = this.querySelector('[data-load-previous]');
    this.loadNext = this.querySelector('[data-load-next]');
    this.loadPreviousButton = this.querySelector('[data-load-previous] .button');
    this.loadNextButton = this.querySelector('[data-load-next] .button');
    this.statusContainer = this.querySelector('.infinite-scroll--status');

    this.storedPage = this.searchParams.get('page');

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (this.searchParams.get('page') && parseInt(this.searchParams.get('page')) > 1) {
      this.loadPrevious.classList.remove('hide');

      this.loadPrevious.querySelector('button').addEventListener('click', e => {
        e.preventDefault();

        this.handlePrevious();
      });
    }

    this.bindCardClickEvents();
  }

  connectedCallback() {
    if (this.loadNext) {
      this.loadNext.querySelector('button').addEventListener('click', e => {
        this.handleNext();
      });
    } else {
      if (this.elementToObserve) {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          this.handleNext();
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.elementToObserve);
      }
    }
  }

  loadingState(button, enable) {
    button.setAttribute('aria-disabled', enable);
    button.classList.toggle('loading', enable);
    button.querySelector('.loading-overlay__spinner').classList.toggle('hidden', !enable);
  }

  handlePrevious() {
    this.loadingState(this.loadPreviousButton, true);

    fetch(this.currentUrl + '?page=' + (this.storedPage - 1))
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        let docInfiniteScroll = doc.querySelector('infinite-scroll');

        if (docInfiniteScroll.dataset.currentPage == '1') {
          this.loadPrevious.classList.add('hide');
        }

        this.storedPage = this.storedPage - 1;

        if (this.storedPage != 1) {
          this.searchParams.set('page', this.storedPage);
        } else {
          this.searchParams.delete('page');
        }
        window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);

        if (this.targetList) {
          this.targetList.insertAdjacentHTML('afterbegin', docInfiniteScroll.querySelector('ul').innerHTML);
        }

        this.loadedCallback();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleNext() {
    if (this.nextUrl) {
      this.loadingState(this.loadNextButton, true);

      fetch(this.nextUrl)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          let docInfiniteScroll = doc.querySelector('infinite-scroll');

          this.previousUrl = docInfiniteScroll.dataset.previousUrl;
          this.nextUrl = docInfiniteScroll.dataset.nextUrl;
          this.currentPage = docInfiniteScroll.dataset.currentPage;

          if (this.currentPage != '1') {
            this.searchParams.set('page', this.currentPage);
          }

          window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);
          if (this.targetList)
            this.targetList.insertAdjacentHTML('beforeend', docInfiniteScroll.querySelector('ul').innerHTML);
          this.statusContainer.innerHTML = docInfiniteScroll.querySelector('.infinite-scroll--status').innerHTML;

          if (!this.nextUrl) {
            this.loadNext.remove();
          }

          this.loadedCallback();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  loadedCallback() {
    this.loadPreviousButton && this.loadingState(this.loadPreviousButton, false);
    this.loadNextButton && this.loadingState(this.loadNextButton, false);

    // if (loadReviewsIoRatingSnippets) {
    //   loadReviewsIoRatingSnippets();
    // }

    this.bindCardClickEvents();
  }

  bindCardClickEvents() {
    let cards = this.querySelectorAll('.product-grid li a');

    if (cards) {
      for (const card of cards) {
        card.addEventListener('click', e => {
          let link = e.target.href;
          let liItem = e.target.closest('li');

          if (liItem && liItem.dataset.currentPage) {
            e.preventDefault();

            let currentPage = liItem.dataset.currentPage;

            this.searchParams.set('page', currentPage);

            window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);

            window.location.href = link;
          }
        });
      }
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

class PurchasePickerTab extends HTMLElement {
  constructor() {
    super();
    // Check initial class to set correct selling mode
    this.optionsWrapper = this.querySelector('.product-purchase-option-picker__tabs');
    this.selling_mode = this.optionsWrapper?.classList.contains('subscription') ? 'subscription' : 'one-time';
    this.options = this.querySelectorAll('.product-purchase-option-picker__tab');
    this.bundles = this.querySelectorAll('.swatches-wrapper-custom .bundle-pack');
    this.selling_plan_id = this.querySelector('input[name="selling_plan"]');
  }

  connectedCallback () {
    this.options.forEach(option => {
      option.addEventListener('click', this.onOptionClick.bind(this));
    });
  
    this.bundles.forEach(bundle => {
      bundle.addEventListener('click', this.onBundleClick.bind(this));
    });
  
    const showPrice = () => {
      const priceWrapper = this.closest('.product--featured-product')
        ?.querySelector('.product__info-wrapper .product__price.price_wrapper');
      if (priceWrapper) {
        priceWrapper.classList.remove('price--hidden');
        priceWrapper.style.visibility = '';
      }
    };
  
    // Trigger subscription tab click if in subscription mode to update prices
    if (this.selling_mode === 'subscription') {
      const subscriptionTab = this.querySelector('.product-purchase-option-picker__tab.subscription');
      if (subscriptionTab) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (subscriptionTab && this.contains(subscriptionTab)) {
              subscriptionTab.click();
            }
            showPrice();
          }, 200);
        });
      }
    } else {
      showPrice();
    }
  }

  onOptionClick(event) {
      event.preventDefault();
      let currentOption = event.target;
      // Handle case where click might be on child element
      if (!currentOption.classList.contains('buy-now') && !currentOption.classList.contains('subscription')) {
        currentOption = currentOption.closest('.product-purchase-option-picker__tab');
      }
      
      const productPriceRegular = this.closest('.product--featured-product')?.querySelector('.product__info-wrapper .product__price.price_wrapper span.price-item.price-item--regular');
      const productPriceSale = this.closest('.product--featured-product')?.querySelector('.product__info-wrapper .product__price.price_wrapper span.price-item.price-item--sale');

      if (currentOption && currentOption.classList.contains('buy-now')) {
        this.selling_mode = 'one-time';
        this.optionsWrapper.classList.remove('subscription');
        this.optionsWrapper.classList.add('buy-now');
        if (this.selling_plan_id) {
          this.selling_plan_id.value = "";
        }
        const normalPrice = this.querySelector('.swatches-wrapper-custom .bundle-pack input[type=radio]:checked+label .normal-price');
        if (normalPrice && productPriceRegular) {
          productPriceRegular.innerHTML = normalPrice.innerHTML;
        }
        if (normalPrice && productPriceSale) {
          productPriceSale.innerHTML = normalPrice.innerHTML;
        }
      } else if (currentOption && currentOption.classList.contains('subscription')) {
        this.selling_mode = 'subscription';
        this.optionsWrapper.classList.remove('buy-now');
        this.optionsWrapper.classList.add('subscription');
        const activeOption = this.querySelector('.purchase-options-selector__option.active');
        if (activeOption && this.selling_plan_id) {
          this.selling_plan_id.value = activeOption.getAttribute('data-id');
        }
        const newPrice = this.querySelector('.swatches-wrapper-custom .bundle-pack input[type=radio]:checked+label .new-price');
        if (newPrice && productPriceRegular) {
          productPriceRegular.innerHTML = newPrice.innerHTML;
        }
        if (newPrice && productPriceSale) {
          productPriceSale.innerHTML = newPrice.innerHTML;
        }
      }
  }

  onBundleClick(event) {
    const productPriceRegular = this.closest('.product--featured-product').querySelector('.product__info-wrapper .product__price.price_wrapper span.price-item.price-item--regular');
    const productPriceSale = this.closest('.product--featured-product').querySelector('.product__info-wrapper .product__price.price_wrapper span.price-item.price-item--sale')
    if (this.selling_mode == 'subscription') {
      setTimeout(() => {
        productPriceRegular.innerHTML = event.target.closest('.bundle-pack').querySelector('.new-price').innerHTML;
        productPriceSale.innerHTML = event.target.closest('.bundle-pack').querySelector('.new-price').innerHTML;
      }, 100);
    } else {
      setTimeout(() => {
        productPriceRegular.innerHTML = event.target.closest('.bundle-pack').querySelector('.normal-price').innerHTML;
        productPriceSale.innerHTML = event.target.closest('.bundle-pack').querySelector('.normal-price').innerHTML;
      }, 100);
    }
  }
}

customElements.define('purchase-picker-tab', PurchasePickerTab);

class PurchaseOptionsSelector extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.purchase-options-selector__header');
    this.options = this.querySelectorAll('.purchase-options-selector__option');

    this.header.addEventListener('click', this.onHeaderClick.bind(this));
    this.options.forEach(option=> {
      option.addEventListener('click', this.onOptionClick.bind(this));
    });
  }

  onHeaderClick(event) {
    event.preventDefault();
    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      this.classList.add('active');
    }
  }

  onOptionClick(event) {
    event.preventDefault();
    let currentOption = event.target;
    if(currentOption.classList.contains('title')) currentOption = currentOption.closest('.purchase-options-selector__option');
    this.header.querySelector('.title').innerHTML = currentOption.querySelector('.title').innerHTML;
    this.classList.remove('active');

    this.options.forEach(option=> {
        option.classList.remove('active');
    });

    currentOption.classList.add('active');

    const plan_id = currentOption.dataset.id;
    this.closest('.product-purchase-options-picker__wrapper').querySelector('[name="selling_plan"]').value = plan_id;
  }
}

customElements.define('purchase-options-selector', PurchaseOptionsSelector);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product--featured-product').forEach((productEl) => {
    const hasPurchasePicker = productEl.querySelector('purchase-picker-tab');
    const priceWrapper = productEl.querySelector('.product__info-wrapper .product__price.price_wrapper');

    // If there is no subscription widget on this product, never keep the price hidden
    if (priceWrapper && !hasPurchasePicker) {
      priceWrapper.classList.remove('price--hidden');
      priceWrapper.style.visibility = '';
    }
  });
});